import React, { Component } from 'react'

import jsonService from '../services/getJSON';

import Form from './form/Form';
import SignatureResultsContainer from './signatureResults/signatureResultsContainer';
import Controls from './controls/Controls';

import sampleData from '../data/sample';

class App extends Component {

	constructor(props){
		super(props);

		this.state = {
			contactInfo: sampleData.clear,
			disclaimers: [],
			logos: []
		}

		this.handleFormChange = this.handleFormChange.bind(this);
		this.handleControlChange = this.handleControlChange.bind(this);
		this.getDisclaimerInfo = this.getDisclaimerInfo.bind(this);
		this.getLogos = this.getLogos.bind(this);
	}

	componentDidMount(){
		this.getDisclaimerInfo();
		this.getLogos();
	}

	getDisclaimerInfo(){
		jsonService.getDisclaimers()
			.then(response =>{
				this.setState({
					disclaimers: response
				})
			})
			.catch(error =>{
				console.log("Disclaimer Error", error)
			})
	}

	getLogos(){
		jsonService.getLogos()
			.then(response =>{
				this.setState({
					logos: response
				})
			})
			.catch(error =>{
				console.log("Logo Error", error)
			})
	}


	handleFormChange(formField, value){
		// Update the object in a temp object
		var tempContactInfo = this.state.contactInfo;
		tempContactInfo[formField] = value;
		
		// Set temp object to the state object
		this.setState({
			contactInfo: tempContactInfo
		});
	}

	handleControlChange(option){
		switch (option){
			case "sample":

				this.setState({
					contactInfo : sampleData.sample
				});
				break;
			default:
				this.setState({
					contactInfo: sampleData.clear
				});
				break;
		}

	}

	render(){
		const { contactInfo } = this.state;

		return(
			<div className="signatureMaker">
				<Controls 
					handleInput={(event) => { this.handleControlChange(event.target.name) }}  />
					
				<Form handleFormChange={(event) => { this.handleFormChange(event.target.name, event.target.value)}}
					  contactInfo={contactInfo}
					  disclaimers={this.state.disclaimers}
					  logos={this.state.logos} />
				
				<SignatureResultsContainer 
					contactInfo={contactInfo}
					disclaimers={this.state.disclaimers}
					logos={this.state.logos} />
			</div>
		)
	}
}

export default App;